module.exports = __webpack_public_path__ + "static/media/cara_sad_eyes_open_mouth_open.71772ebb.png";